export const MODULES = {
  AIR: "Air",
  HOTEL: "Hotel",
};
